import {RadioGroup} from "@blueprintjs/core";
import {COLORS} from "../../constants/constants";
import styled from "@emotion/styled";

export const StyledRadioGroup = styled(RadioGroup)<{horizontal?: boolean}>`
  width: 100%;
  display: flex;
  flex-direction: ${(props) => (props.horizontal ? "row" : "column")};
  gap: 12px;

  .bp5-control input:checked ~ .bp5-control-indicator {
    background-color: ${COLORS.DARK_BLUE} !important;
  }
  .bp5-control input:checked ~ span {
    color: ${COLORS.TEXT_BLACK} !important;
  }

  .bp5-radio {
    height: 16px;
    margin: 0;
  }

  .bp5-label {
    margin: 0;
  }
`;
